import script from "./captchaField.vue?vue&type=script&setup=true&lang=ts"
export * from "./captchaField.vue?vue&type=script&setup=true&lang=ts"

import "./captchaField.vue?vue&type=style&index=0&id=b8e73e22&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8e73e22"]])

export default __exports__